// This is basically the same as /routers/tenant.ts except that it uses /routes/lobby instead of /routes/tenant.
// We use different routers because some paths (like '/') are different depending on whether or not the request path
// contains a subdomain. Since the routes are in different files, we need different routers.

// TODO: could we import most of this from /routers/tenant.ts to reduce duplication here?

import { createRouter, createWebHistory } from 'vue-router'
import theLeegRoutes from '@/routes/lobby'
import coSoccerRoutes from '@/routes/cosoccer'
import { useAuthStore } from '@/stores/auth.store'
import { rootDomain, rootUrl, subdomainUrl } from '@/utils/helpers/urlHelpers'
import { showSnackbar } from '@/utils/showSnackbar'


// CJS - code below is from https://codesandbox.io/p/sandbox/scroll-to-hash-in-vue-router-veofl?file=%2Fsrc%2Frouter.js%3A2%2C1-25%2C4
// it was found in router.js (note: .js vs .ts)
// This may be the answer to enable hash tags (in help)
// Defering for now
//
//import VueRouter from "vue-router";
//Vue.use(VueRouter);
//const router = new VueRouter({
//  mode: "history",
//  routes: [
//    { path: "/", component: Home },
//    { path: "/about", component: About }
//  ],
//  scrollBehavior(to, from, savedPosition) {
//    if (savedPosition) {
//      return savedPosition;
//    }
//    if (to.hash) {
//      return {
//        selector: to.hash,
//        behavior: "smooth"
//      };
//    }
//  }
//});

const routes = rootDomain() == 'theleeg.com' ? theLeegRoutes :
                rootDomain() == 'cosoccer.org' ? coSoccerRoutes : []
//const routes = () => {
//  switch(rootDomain()) {
//    case 'theleeg.com': {
//        //statements;
//        TLroutes
//        break;
//    }
//    case 'cosoccer.org': {
//        //statements;
//        TLroutes
//        break;
//    }
//    default: {
//        //statements;
//        []
//        break;
//    }
//  }
//}

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from) => {
  // Used for shared/lobby pages like /login, /signup, etc.
  if (to.meta.forceRedirect && location.host != rootUrl().replace(/\//g, '')) {
    location.href = rootUrl() + to.name
  }
})

// For every visited path, check if user's role allows access. If not, redirect to their dashboard page.
// We use beforeResolve here (instead of guards that trigger earlier) to allow all the async route components
// to complete so that the authStore is populated with a user and roles.
router.beforeResolve(async (to, from) => {
  console.log('lobby router')

  const authStore = useAuthStore()

  if (to.meta.roles.includes('ALL')) {
    console.log('public route:', to.name)
  } else if (authStore.isAuthenticated) {
    if (to.name == 'refereeReport') {
      if (authStore.currentRole != 'referee') {
        return { name: 'profile' }
      }
    }
    else if (to.name == 'acceptWaiver') {
      if (authStore.currentRole != 'player') {
        return { name: 'profile' }
      }
    }
    else if (to.meta.layout != 'DashboardLayout') {
      if (!(to.name == 'message' && from.name == 'admin-posts') && !(to.name == 'message' && from.name == 'auto-comms') && !(to.name == 'login' && from.name == 'free-agents') && !(to.name == 'gameMode' && from.name == 'gameReport')) {
        authStore.setCurrentAccountIndex(null)
        authStore.setCurrentRole('')
        authStore.setCurrentParticipant(null)
      }
    }
    else {  // If set to go to a Dashboard & authStore.currentRole == '', return to profile - this happens on a browser referesh of any Dashboard
            // This may be undesirable - may want to save more info (like entire authStore state) in session storage (search for sessionstorage)
      if (authStore.currentRole == '') {
        console.log('Current Role Clear')
        return { name: 'profile' }
      }

      if (!(to.meta.roles.some((role) => authStore.currentRole.includes(role)))) {
        console.log('Current Role Error')
        return { name: 'profile' }
      }
    }

// CJS - COMMMENTED OUT ON 2/6/2025 - This should be handled when logging in
// CJS - unCOMMMENTED OUT ON 2/7/2025 - while this is hanlded when logging in, it is not handled when directly typeing in theleeg.com/profile after logging in
// CJS - COMMMENTED OUT ON 1/8/2026 - Attempt to move this check to ProfilePage.vue (OnBeforeMount())
//    console.log('authStore.currentUser:', authStore.currentUser)
//    if (authStore.currentUser) {
//      if (authStore.currentUser.TOU) {
//        const TOUdate = new Date(authStore.currentUser.TOU)
//        const minTOUDate = new Date('2024-10-02')

//        if (TOUdate < minTOUDate) {
//          // CJS - this is debug - if these are printed TOU check failed (sometimes incorrectly)
//          console.log('TOUdate < minTOUDate')
//          console.log('TOUdate:', TOUdate)
//          console.log('minTOUDate:', minTOUDate)
//          return { name: 'terms-of-use'}
//        }
//      }
//      else {
//        // CJS - this is debug - if these are printed TOU check failed (sometimes incorrectly)
//        console.log('authStore.currentUser.TOU not found')
//        console.log('authStore.currentUser.TOU:',authStore.currentUser.TOU)
//        return { name: 'terms-of-use'}
//      }
//    }
//    else {
//      // CJS - this is debug - if this is printed TOU check failed (sometimes incorrectly)
//      console.log('authStore.currentUser not found')
//      return { name: 'terms-of-use'}
//    }

    console.log('route matched', to.name)
  } else {
    console.log('invalid route', to.name)
    // showSnackbar('You do not have access to that page', 'error')
    return { name: 'lobby' }
  }
})

export default router
